<i18n>
{
  "fr": {
    "configuratorQuantitySelect": {
      "label": "Quantité",
      "noQuantity": "Produit indisponible"
    }
  }
}
</i18n>
<template>
  <div
    class="configurator-quantity-select"
    :class="{ 'configurator-quantity-select--disabled': disabled }"
  >
    <label
      :for="id"
      class="configurator-quantity-select__label"
      :class="{ 'configurator-quantity-select__label--required': required }"
      v-text="$t('configuratorQuantitySelect.label')"
    ></label>

    <div
      v-if="options.length"
      class="configurator-quantity-select__select-wrapper"
    >
      <select
        :id="id"
        v-model.number="internalValue"
        :required="required"
        name="quantity"
        class="configurator-quantity-select__select"
      >
        <option
          v-for="option in options"
          :key="option.id"
          :value="option.id"
          :required="required"
          v-text="option.name"
        ></option>
      </select>
      <span class="configurator-quantity-select__arrow-icon"></span>
    </div>

    <span v-else v-text="$t('configuratorQuantitySelect.noQuantity')"></span>
  </div>
</template>

<script>
import {
  ConfiguratorAction,
  prefixType as prefixConfiguratorType,
} from '../../store/modules/configurator';
import {
  GlassesGetter,
  prefixType as prefixGlassType,
} from '../../store/modules/configurator/glasses';
import { randomStr } from '../../utils/String';

export default {
  name: 'ConfiguratorQuantitySelect',
  emits: ['input'],
  props: {
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
    },
    // If true, use v-model instead of store
    useVModel: {
      type: Boolean,
      default: false,
    },
    // Value when using v-model mode (Vue 2 uses 'value' prop for v-model)
    value: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: randomStr(),
    };
  },
  computed: {
    options() {
      return (
        this.$store.getters[
          prefixGlassType(GlassesGetter.GET_MATCHING_QUANTITIES)
        ] || []
      );
    },
    internalValue: {
      get() {
        // Use v-model value if useVModel is true, otherwise use store
        if (this.useVModel) {
          return this.value;
        }

        return this.$store.state.configurator.activeQuantityId;
      },
      set(quantityId) {
        // Emit input event if useVModel is true, otherwise update store
        if (this.useVModel) {
          this.$emit('input', quantityId);
        } else {
          this.$store.dispatch(
            prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
            { quantityId }
          );
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-quantity-select {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  color: $color-gray-wild-sand;
  font-size: 1rem;
  position: relative;

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  &__label {
    @include breakpoint($breakpoint-l) {
      font-size: 1.25rem;
    }
  }

  &__select {
    $select-padding: 0.5rem;

    color: inherit;
    border: 0;
    border-radius: 0;
    padding-top: 1.25rem;
    margin-top: -1.25rem;
    padding-right: $select-padding + 2rem;
    appearance: none;
    font-weight: 600;
    background: none;
    font-size: 17px; // Force 17px to prevent zoom on iOs devices when focused
    cursor: pointer;

    @include breakpoint($breakpoint-l) {
      font-size: 1.5rem;
    }
  }

  &__select-wrapper {
    display: flex;
  }

  &__arrow-icon {
    transform: rotate(90deg) translateX(-50%);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 50%;

    &::before {
      @extend %icon;
      @extend %icon--arrow-right;
    }
  }
}
</style>
